import './add-client.scss'

import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { useMachine } from '@xstate/react'

import { ApiDfm } from '../../../api/_legacy/generated-api'
import {
  Close,
  GenericValidationMessages,
  OperationButton,
  Section,
  Space
} from '../../../components/core-v2'
import Icon from '../../../components/core-v2/atoms/Icon'
import IconButton from '../../../components/core-v2/molecules/iconButton'
import LinkIcon from '../../../components/core-v2/molecules/linkIcon'
import { Mutation } from '../types'
import { DfmEditor } from './dfm-editor'
import { addDfmMachine } from './state/add-dfm-machine.state'

export type Props = {
  onAddComplete: () => void
  onClose: () => void
}

const StyledClientConfirm = styled.div`
  display: grid;
  grid-template-rows: 91px auto;
`

export const addDfmSuccessMessage = 'The new portfolio manager has been created'

export function AddDfm({ onAddComplete, onClose }: Props) {
  const [state, send] = useMachine(addDfmMachine)

  const mutateDfm = (mutation: Mutation<ApiDfm>) => send({ type: 'MUTATE', mutation })

  if (state.matches('saveSuccess')) {
    return (
      <StyledClientConfirm className="add-a-new-client-confirm">
        <header className="CustomMuiTitleContainer-root">
          <Typography color="textPrimary">{addDfmSuccessMessage}</Typography>
        </header>
        <Space isflex justifyContent="center" p={5}>
          <div className="button">
            <OperationButton operationType="progress" onClick={() => onAddComplete()}>
              Ok
            </OperationButton>
          </div>
        </Space>
      </StyledClientConfirm>
    )
  }

  const StyledNewDfmWrapper = styled.div`
    width: 800px;
    display: flex;
    flex-direction: column;
    max-height: calc(80vh - 50px);
  `

  const StyledNewDfmBlock = styled.div``

  return (
    <StyledNewDfmWrapper key="add_new_dfm_container">
      <Section type="secondary">
        <Space isflex alignItems="center" justifyContent="space-between" pl={5} py={6}>
          <Typography color="textPrimary">Add a portfolio manager</Typography>
          <Close onClick={() => onClose()} />
        </Space>
      </Section>
      <StyledNewDfmBlock key="dfm_edit_form_container">
        <DfmEditor
          dfmName={state.context.dfm.dfmName}
          errors={state.context.errors}
          onMutate={mutateDfm}
        />
      </StyledNewDfmBlock>
      <GenericValidationMessages errorMessages={state.context.errorMessages} />
      <Section type="quaternary">
        <Space isflex justifyContent="space-between" px={5} py={6}>
          <LinkIcon
            disabled={false}
            icon={<Icon name="chevronLeft" size="small" />}
            iconPosition="left"
            text="Cancel and go back"
            onClick={() => onClose()}
          />
          <IconButton
            data-testid="add-dfm-button"
            disabled={!state.context.isSaveEnabled}
            icon={<Icon name="circleAdd" size="default" />}
            iconPosition="left"
            operationType="progress"
            text="Add portfolio manager"
            onClick={() => send({ type: 'SAVE', dfm: state.context.dfm })}
          />
        </Space>
      </Section>
    </StyledNewDfmWrapper>
  )
}
